import "./EntityElement.css";
import { Entity } from "./Entity.ts";

export class EntityElement extends HTMLElement {
  constructor(readonly model: Entity) {
    super();
  }

  render() {
    this.style.setProperty("--x", this.model.position.x.toString());
    this.style.setProperty("--y", this.model.position.y.toString());
    this.style.setProperty("--angle", this.model.angle.toString());
    this.style.setProperty("--color", this.model.color);
    this.style.setProperty("--radius", this.model.radius.toString());
    this.style.setProperty("--text", `"${this.model.text}"`);
  }
}

customElements.define("entity-element", EntityElement);
